import { fetchCouncilorReqList } from "api/counsilors";
import ApproveCounsilor from "components/Modal/ApproveCounsilor";
import CounsilorDetails from "components/Modal/CounsilorDetails";

import { changeCounsilor } from "api/counsilors";
import RejectCounsilor from "components/Modal/RejectCounsilor";
import {
  setLoading,
  setSelectedUser,
  setTotalPageNo,
  setWardsCurrentPageNo,
} from "pages/AllWards/allWardsSlice";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import TabComp from "themes/elements/Tab";
import WardsApprovelTable from "themes/elements/Table/WardsApprovelTable";
function WardsApprovalManagement() {
  const dispatch = useDispatch();
  const [filterRegion, setFilterRegion] = useState(null);
  const [filterReason, setFilterReason] = useState(null);
  const [filterStatus, setFilterStatus] = useState({ value: 4, name: "All" });
  const [filterWard, setFilterWard] = useState(null);
  const [filterCouncillor, setFilterCouncillor] = useState(null);
  const [filterReqCouncillor, setFilterReqCouncillor] = useState(null);
  const isFirstLoad = useRef(true); // Ref to track first load

  const [details, setDetails] = useState(false);
  const [filterTerm, setFilterTerm] = useState();
  const [tabActive, setTabActive] = useState("1");
  const [isApprove, setIsApprove] = useState(false);
  const [isDetailsModal, setIsDetailsModal] = useState(false);

  const [isChangeLoading, setIsChangeLoading] = useState(false);

  const [isReject, setIsReject] = useState(false);
  const columnData = [
    {
      title: "REGION",
      key: "region_name",
      filter: "searchTitle",
      width: 230,
    },
    {
      title: "WARD NO.",
      key: "ward",
      filter: "searchNumber",
      width: 150,
    },
    {
      title: "COUNCILLOR",
      key: "councillor",
      filter: "searchCouncillor",
      width: 300,
    },
    {
      title: "councillor term",
      key: "term",
      filter: "datePicker",
      width: 259,
    },
    {
      title: "REquested by",
      key: "created_user_name",
      filter: "searchRequsted",
      width: 300,
    },
  ];
  if (tabActive === "2") {
    columnData.splice(5, 0, {
      title: "Status",
      key: "status",
      filter: "selectStatus",
      dropDown: [
        { value: 4, name: "All" },
        { value: 1, name: "Approved" },
        { value: 3, name: "Rejected" },
      ],
      chip: true,
      width: 175,
    });
  }

  const [recipientsData, setRecipientsData] = useState([]);
  const { isLoading, selectedUser, currentPageNo, totalPageNo } = useSelector(
    (state) => state.wards
  );

  const loadWards = async () => {
    dispatch(setLoading(true));

    try {
      const params = {
        page: currentPageNo,
        perPage: 10,
        councilorName: filterCouncillor && filterCouncillor,
        regionId: filterRegion && filterRegion,
        wardCode: filterWard && Number(filterWard),
        mapStatusFlg: tabActive === "1" ? 2 : filterStatus.value,
        reason: filterReason ? filterReason : "",
        requestedBy: filterReqCouncillor ? filterReqCouncillor : "",
      };

      if (filterTerm && filterTerm.length === 2) {
        params.termStartDate = reformatDate(filterTerm[0]);
        params.termEndDate = reformatDate(filterTerm[1]);
      }
      const res = await fetchCouncilorReqList(params);
      if (res?.meta) {
        if (currentPageNo === 1) {
          dispatch(setTotalPageNo(res.meta.last_page * 10)); // Changed to totalPages, if your API returns total pages directly, use that instead of last_page * 10
        }
        dispatch(setWardsCurrentPageNo(res.meta.current_page)); // Use currentPage directly if it's provided
      }
      const wardOptions = res?.wards?.map((ward) => ({
        region: `${ward?.region_id} `,
        councillor:
          ward?.first_name && ward?.last_name
            ? `${ward.first_name} ${ward.last_name}`
            : null,
        ward: Number(ward?.ward_code),
        term: ward?.term,
        ...ward,
      }));
      if (wardOptions?.length > 0) {
        setRecipientsData([...wardOptions]);
      } else {
        setRecipientsData([]);
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
    }
  };
  // First useEffect to handle initial data load
  useEffect(() => {
    dispatch(setWardsCurrentPageNo(1)); // Set the page number to 1
  }, [dispatch]);

  useEffect(() => {
    if (currentPageNo === 1 && isFirstLoad.current) {
      loadWards(); // Trigger the initial data load after currentPageNo is set
      isFirstLoad.current = false; // Set first load flag to false
    }
  }, [currentPageNo]);

  // Second useEffect to handle loadWards after currentPageNo is set to 1
  useEffect(() => {
    if (!isFirstLoad.current) {
      loadWards(); // Only load data after the first render
    }
  }, [
    currentPageNo,
    tabActive,
    filterTerm,
    filterReason,
    filterWard,
    filterCouncillor,
    filterRegion,
    filterStatus,
    filterReqCouncillor,
  ]);

  const reformatDate = (dateStr) => {
    const parts = dateStr.split("-");
    return `${parts[2]}-${parts[1]}-${parts[0]}`; // Concatenate in the new order
  };
  const tabsData = [
    {
      key: "1",
      label: "Pending",
      children: (
        <>
          {tabActive === "1" && (
            <WardsApprovelTable
              isLoading={isLoading}
              setIsApprove={setIsApprove}
              column={columnData}
              data={recipientsData}
              filterRegion={filterRegion}
              setFilterRegion={setFilterRegion}
              filterWard={filterWard}
              setFilterWard={setFilterWard}
              filterCouncillor={filterCouncillor}
              setFilterCouncillor={setFilterCouncillor}
              dataClick={(data) => {
                dispatch(setSelectedUser(data));
                setDetails(true);
              }}
              approve
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              filterTerm={filterTerm}
              setFilterTerm={setFilterTerm}
              setFilterReason={setFilterReason}
              filterReason={filterReason}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              setIsReject={setIsReject}
              setIsDetails={setIsDetailsModal}
              setFilterReqCouncillor={setFilterReqCouncillor}
              filterReqCouncillor={filterReqCouncillor}
            />
          )}
        </>
      ),
    },
    {
      key: "2",
      label: "History",
      children: (
        <>
          {tabActive === "2" && (
            <WardsApprovelTable
              isLoading={isLoading}
              column={columnData}
              setIsApprove={setIsApprove}
              data={recipientsData}
              filterRegion={filterRegion}
              setFilterRegion={setFilterRegion}
              filterWard={filterWard}
              setFilterWard={setFilterWard}
              filterCouncillor={filterCouncillor}
              setFilterCouncillor={setFilterCouncillor}
              dataClick={(data) => {
                dispatch(setSelectedUser(data));
                setDetails(true);
              }}
              setFilterReason={setFilterReason}
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              filterTerm={filterTerm}
              setFilterTerm={setFilterTerm}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              setIsReject={setIsReject}
              setIsDetails={setIsDetailsModal}
              setFilterReqCouncillor={setFilterReqCouncillor}
              filterReqCouncillor={filterReqCouncillor}
            />
          )}
        </>
      ),
    },
  ];

  function handleTabChange(key) {
    setFilterStatus({ value: 4, name: "All" });

    dispatch(setWardsCurrentPageNo(1));
    setTabActive(key);
    setFilterRegion("");
    setFilterWard("");
    setFilterTerm();
    setFilterCouncillor("");
    setFilterReason();
    setFilterReqCouncillor();
  }

  const handleFormSave = async (approval, reason) => {
    setIsChangeLoading(true);
    try {
      const res = await changeCounsilor(
        approval
          ? {
              wardCode: String(selectedUser?.ward),
              councilorMapWardId: selectedUser?.councilor_map_ward_id,
              mapStatusFlg: 1,
              councilorId: selectedUser?.councilor_id,
              reason: "Councilor change request approved",
            }
          : {
              wardCode: String(selectedUser?.ward),
              councilorMapWardId: selectedUser?.councilor_map_ward_id,
              councilorId: selectedUser?.councilor_id,
              mapStatusFlg: 3,
              reason: reason,
            }
      );

      if (res) {
        loadWards();
        toast.success(res?.message);
        setIsApprove(false);
        setIsReject(false);
      }
    } catch (error) {
    } finally {
      setIsChangeLoading(false);
    }
  };

  return (
    <div className="page-wrapper flex flex-column gap-4">
      <>
        <h2 className="page-title">Approval management</h2>
        <TabComp
          isLoading={isLoading}
          tabActive={tabActive}
          handleTabChange={handleTabChange}
          // exportData={selectedData}
          // count={selectedData?.length}
          data={tabsData}
        />
        <RejectCounsilor
          setIsReject={setIsReject}
          isChangeLoading={isChangeLoading}
          isReject={isReject}
          selectedData={details}
          data={details}
          handleRejectCounsilor={(reason) => handleFormSave(false, reason)}
        />
        <ApproveCounsilor
          setIsApprove={setIsApprove}
          isApprove={isApprove}
          selectedData={details}
          isChangeLoading={isChangeLoading}
          data={details}
          handleApproveCounsilor={() => {
            handleFormSave(true);
          }}
        />
        <CounsilorDetails
          tabActive={tabActive}
          setDetails={setIsDetailsModal}
          isDetails={isDetailsModal}
          selectedData={selectedUser}
          data={selectedUser}
        />
      </>
    </div>
  );
}

export default WardsApprovalManagement;
